var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"cols":"12","md":"6","lg":"3"}},[_c('v-card',{attrs:{"color":_vm.getColor,"dark":""}},[_c('v-card-subtitle',[_vm._v(_vm._s(_vm.title))]),_c('v-card-title',{staticClass:"text-h5"},[_c('span',[_vm._v(_vm._s(_vm.content))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }